import axios from "axios";

export const LOGIN_URL = "/auth/login";
export const REGISTER_URL = "/api/auth/register";
export const REQUEST_PASSWORD_URL = "/auth/forgot-password";
export const REQUEST_OTP_URL = "/auth/2fa-otp";
export const RESET_URL = "/auth/reset-password";

export const ME_URL = "/admins/me";

export function login(email, password) {
  return axios.post(LOGIN_URL, { email, password });
}

export function reAuth(email, password, userId) {
  return axios.post(`${LOGIN_URL}?action=reauth&userId=${userId}`, { email, password });
}

export function otpValidation(values) {
  return axios.post(REQUEST_OTP_URL, { ...values });
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function resetPassword(ref, password) {
  return axios.post(RESET_URL, { ref, password });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}
